import { useMutation } from 'react-query';
import { setUserPin } from '@higo/api/lib/services';
import { SetPinDTO } from '@higo/api/lib/models/setPinDTO';
import { useMicrositeApiContext } from 'contexts/MicrositeApiContext';

export const useSetUserPinMutation = () => {
  const { baseAxios } = useMicrositeApiContext();

  return useMutation((dto: SetPinDTO) => setUserPin(baseAxios)(dto), {
    onSuccess: () => {
      // toast.success(
      //   intl.formatMessage({
      //     id: 'authentication.setPinCode.successMessage',
      //   }),
      // );
    },
  });
};
